<template>
    <div class="d-flex flex-column" style="height: 100%">
        <v-tabs
            v-model="tab"
            class="flex-shrink-0 flex-grow-0 w-100"
            color="primary"
            grow
        >
            <v-tab
                v-for="name in tabNames"
                :key="name"
                class="text-uppercase text-medium-emphasis text-title-small"
                style="letter-spacing: 1.25px"
            >
                {{ name }}
            </v-tab>
        </v-tabs>
        <v-window
            v-model="tab"
            class="
                pt-6
                text-body-large text-typography1
                overflow-y-auto
                styled-scrollbar
                flex-grow-1 flex-shrink-1
            "
            style="height: 100%"
        >
            <v-window-item>
                <Assumptions :calc="calc" />
            </v-window-item>
            <v-window-item>
                <VersionHistory :calc="calc" />
            </v-window-item>
            <v-window-item>
                <Information
                    :version="version"
                    :createdBy="createdBy"
                    :lastUpdate="lastUpdate"
                    :calcId="calcId"
                    :persistentCalcId="persistentCalcId"
                    :additionalLinks="additionalLinks"
                    :additionalAuthors="additionalAuthors"
                />
            </v-window-item>
        </v-window>
    </div>
</template>
<script setup>
import { ref, computed } from 'vue'
import Information from './tabs/Information.vue'
import Assumptions from './tabs/Assumptions.vue'
import VersionHistory from './tabs/VersionHistory.vue'

const props = defineProps({
    calc: {
        type: Object,
        required: true,
    },
    libraryVersion: {
        type: Object,
        required: true,
    },
})

const tab = ref(0)

const tabNames = computed(() => {
    const tabs = []
    if (props.calc.assumptions)
        tabs.push(`Assumptions (${props.calc.assumptions.length})`)
    else tabs.push('Assumptions')
    if (props.calc.changeLog)
        tabs.push(
            `Version History (${props.calc.changeLog.slice().reverse().length})`
        )
    else tabs.push('Version History')
    tabs.push('Information')
    return tabs
})

const version = computed(() => props.libraryVersion.version)
const createdBy = computed(() => props.calc.authorEmail)
const lastUpdate = computed(() =>
    new Date(props.libraryVersion.date).toDateString()
)
const calcId = computed(() => props.calc.calcId)
const persistentCalcId = computed(() => props.calc.persistentCalcID)
const additionalLinks = computed(() => props.calc.additionalInformationLinks)
const additionalAuthors = computed(() => props.calc.additionalAuthors)
</script>
